import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    Navigate,
} from "react-router-dom";

import Dashboard from "pages/Dashboard";
import Courses from "pages/Courses";
import Support from "pages/Support";
import Layout from "components/Layout";

const Router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="courses" element={<Courses />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="support" element={<Support />} />
        </Route>,
    ),
);

export default Router;
